import { Alert, Divider, Typography } from "antd";
import { useState } from "react";
import K from "utilities/constants";
import { ConfirmDelete } from "../../../../../../common/components/modal/confirmDelete/confirmDelete";

import "../../../../create/jobCard.scss";

const { Text } = Typography;

const getJobStatusColor = (status) => {
  status = status?.toLowerCase();
  return ["open", "closed", "on hold"].includes(status) ? status : "custom";
};

export const DeleteJobModal = ({
  job,
  open,
  loading,
  onCancel,
  onDelete,
}) => {
  const [deleteResponse, setDeleteResponse] = useState(null);

  const onConfirm = async () => {
    setDeleteResponse(null);
    try {
      await onDelete();
    } catch (e) {
      setDeleteResponse(e.message);
      throw e;
    }
  };

  return (
    <ConfirmDelete
      open={open}
      onCancel={onCancel}
      onConfirm={onConfirm}
      loading={loading}
      title="Are you sure?"
      okText="Delete Job"
    >
      The following job will be deleted:
      <Divider style={{ margin: 0, marginBottom: 10, marginTop: 10 }} />
      <div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <strong>
            <font style={{ fontSize: 26, color: "#278dc0" }}>{job?.title}</font>
          </strong>
          <Text
            className={K.JobStatus[getJobStatusColor(job?.jobStatus?.name)]}
          >
            <span className="dot"></span>
            {job?.jobStatus?.name}
          </Text>
        </div>
        <strong>Location: </strong>
        {job?.jobLocation?.name}{" "}
      </div>
      <div>
        <strong>Current Openings: </strong>
        {job?.totalOpenings}
      </div>
      <div>
        <strong>Cancelled?: </strong>
        {job?.isCancel === 0 ? "No" : "Yes"}
      </div>
      {deleteResponse && (
        <>
          <Divider style={{ margin: 0, marginTop: 30 }} />
          <div style={{ marginTop: 20 }}>
            <Alert
              style={{ whiteSpace: "break-spaces" }}
              showIcon
              type="error"
              message={
                <>
                  <strong>Error:&nbsp;</strong>
                  <Text>{deleteResponse}</Text>
                </>
              }
            />
          </div>
        </>
      )}
    </ConfirmDelete>
  );
};
